async function postCartUpdate(lineIndex, itemQuantity) {
  const result = await fetch('/cart/change.json', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({line: lineIndex, quantity: itemQuantity})
  });
  return result;
}

function intToMoneyStr(moneyInt, currencySymbol) {
  let moneyStr = currencySymbol + (moneyInt / 100).toFixed(2);
  return moneyStr;
}

function setCurrencySymbol() {
  switch (Shopify.currency.active) {
    case 'GBP':
      return '£';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    default:
      return Shopify.currency.active + ' ';
  }
}

function updateCartInfo(cartJSON) {
  const currencySymbol = setCurrencySymbol();
  let cartItemCount = 0;
  const cartLinePriceElems = document.querySelectorAll('.js-lineprice');
  cartJSON.items.forEach((cartItem, i) => {
    cartItemCount += cartItem.quantity;
    cartLinePriceElems[i].innerText = intToMoneyStr(cartItem.original_line_price, currencySymbol);
  });
  document.querySelector('.js-cartitemcount').innerText = cartItemCount;
  document.querySelector('[data-cartcount]').dataset.cartcount = cartItemCount;
  document.querySelector('.js-cartsubtotal').innerText = intToMoneyStr(cartJSON.items_subtotal_price, currencySymbol);
  if (cartJSON.total_discount) {
    document.querySelector('.js-cartdiscount').innerText = intToMoneyStr(cartJSON.total_discount, currencySymbol);
  }
  document.querySelector('.js-carttotal').innerText = intToMoneyStr(cartJSON.total_price, currencySymbol);
}

async function quantitySelectorChanged(quantitySelectorElem, lineIndex) {
  try {
    const result = await postCartUpdate(lineIndex, quantitySelectorElem.value);
    if (result.ok) {
      updateCartInfo(await result.json());
    } else {
      console.error('Error updating shopping bag: ', result);
    }
  } catch (error) {
    console.error('Error updating shopping bag: ', error);
  }
}

function watchQuantitySelectors(quantitySelectorElems) {
  quantitySelectorElems.forEach((quantitySelectorElem, i) => {
    quantitySelectorElem.addEventListener('change', function() {
      quantitySelectorChanged(quantitySelectorElem, i + 1);
    });
  });
}

watchQuantitySelectors(document.querySelectorAll('.cart__item__quantity select'));
